import ReactDOM from 'react-dom/client'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import { ReactQueryDevtools } from '@tanstack/react-query-devtools'
import { HeroUIProvider } from '@heroui/react'
import { BrowserRouter } from 'react-router-dom'
import { Toaster } from 'sonner'
import { ThemeProvider } from './contexts/ThemeContext'
import { RTLProvider } from './contexts/RTLContext'
import App from './App.tsx'
import './index.css'
import './i18n' // Initialize i18n

// Create a client
const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 1000 * 60 * 5, // 5 minutes
      gcTime: 1000 * 60 * 10, // 10 minutes
    },
  },
})

ReactDOM.createRoot(document.getElementById('root')!).render(
  // <React.StrictMode>
    <BrowserRouter>
      <QueryClientProvider client={queryClient}>
        <RTLProvider>
          <ThemeProvider>
            <HeroUIProvider>
              <App />
              <Toaster richColors position="bottom-right" />
              <ReactQueryDevtools initialIsOpen={false} />
            </HeroUIProvider>
          </ThemeProvider>
        </RTLProvider>
      </QueryClientProvider>
    </BrowserRouter>
  // </React.StrictMode>,
) 